import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate, useParams, useSearchParams } from "react-router-dom";
import PageBanner from "../Components/PageBanner";
import { useAuthContext } from "../Contexts/AuthContext";
import axios from "axios";
import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";
import registerimg from "../assets/entrar.jpg";
import { toast, ToastContainer } from "react-toastify";
import loader from "../assets/loading.gif";
import Navbar from "../Components/Navbar";

const Login = ({ }) => {
  const [searchParams] = useSearchParams();
  const { setUser, user } = useAuthContext();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [Vloading, setVLoading] = useState(false);
  const [vermodal, setvermodal] = useState(false);
  const [vermsg, setvrmessage] = useState("")

  const [credentials, setCredentials] = useState({});
  const { id } = useParams();

  const Check = async () => {
    setVLoading(true);
    try {
      const { data } = await axios.post(
        process.env.REACT_APP_BASE_URL + `/api/auth/verify/${id}`
      );
      setvrmessage(data)
      setvermodal(true)
      setVLoading(false);
    } catch (err) {
      setVLoading(false);
      setvermodal(false)
      toast.error(err.response?.data.error, {
        position: "top-center",
        theme: "dark"
      }
      );
    }
  };

  useEffect(() => {
    if (id !== undefined) {
      Check();
    }
  }, [id]);

  const HandleLogin = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await axios.post(
        process.env.REACT_APP_BASE_URL + "/api/auth/login",
        {
          ...credentials,
          email: credentials.email.toLowerCase(),
        }
      );
      if (data.success) {
        setUser(jwt_decode(data.authToken));
        Cookies.set("token", data.authToken, { expires: 3, secure: true });
        searchParams.get("callback") === "verify"
          ?
          navigate(`/${searchParams.get("callback")}`) :
          navigate("/");
      }
      setLoading(false);
    } catch (err) {
      toast.error(err.response?.data.msg ? err.response?.data.msg : "Please fill all fields!", {
        position: "top-center",
        theme: "dark"
      });
      console.log(err);
      setLoading(false);
    }
  };

  const HandleChange = (e) => {
    setCredentials((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  useEffect(() => {
    const ScrollToTop = () => {
      window.scrollTo(0, 0);
    };
    ScrollToTop();
  }, []);

  if (user) return <Navigate to={"/"} />;
  if (Vloading) return <img src={loader} alt="loading..." className="loader" />;

  return (
    <div className="Login d-flex flex-column justify-content-center align-items-center" style={{ minHeight: "62vh" }}>
      <Navbar />
      <ToastContainer />
      <div
        className="d-flex align-items-center
        mt-10 w-50 login_form mx-auto bg-white px-3 py-5 rounded shadow"
      >
        <form className="w-100" onSubmit={HandleLogin}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <input
              type="email"
              className="form-control w-100"
              id="email"
              aria-describedby="emailHelp"
              onChange={(e) => HandleChange(e)}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">
              Contraseña
            </label>
            <input
              type="password"
              className="form-control w-100"
              id="password"
              onChange={(e) => HandleChange(e)}
            />
            <Link
              to={"/forgotpassword"}
              className="highlight nav-link mt-1 text-end w-100 d-block"
            >
              Recuperar Contraseña
            </Link>
          </div>
          <button type="submit" className="btn continue w-auto">
            {loading ? "Enviando" : "Acceder"}
          </button>
          <p className="text-center mt-2">
            No tengo Cuenta.{" "}
            <Link to="/registro" className="highlight">
              Registrarme Ahora
            </Link>
          </p>
        </form>
      </div>

      {vermodal &&
        <>
          <div className="modal-backdrop fade show"></div>
          <div className="modal show d-block" style={{ zIndex: 200000 }} tabIndex="-1">
            <div className="modal-dialog mx-auto">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">Aviso</h1>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    onClick={() =>
                      setvermodal(false)
                    }></button>
                </div>
                <div className="modal-body">
                  {vermsg}
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-primary bg-p border-0"
                    onClick={() =>
                      setvermodal(false)
                    }>OK</button>
                </div>
              </div>
            </div>
          </div>
        </>
      }
    </div>
  );
};

export default (Login);
